"use strict";var ES5Type=require("../5/Type");module.exports=function(x){return"symbol"==typeof x?"Symbol":"bigint"==typeof x?"BigInt":ES5Type(x)};